<template>
  <SwitchGroup as="div" class="flex items-center" :class="disabled || formDisabled ? 'cursor-not-allowed' : null">
    <Switch
      v-model="content"
      :class="[
        mirror ? 'order-2' : null,
        disabled || formDisabled
          ? content
            ? 'bg-accent-100 dark:bg-accent-900 pointer-events-none'
            : 'bg-neutral-100 dark:bg-neutral-900 pointer-events-none'
          : content
            ? 'bg-accent-600'
            : 'bg-neutral-200 dark:bg-neutral-700',
        'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-hidden focus:ring-2 focus:ring-accent-600 focus:ring-offset-2 dark:ring-offset-neutral-900'
      ]">
      <span
        aria-hidden="true"
        :class="[
          content ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out'
        ]" />
    </Switch>
    <SwitchLabel v-if="label || hint || error" as="span" :class="[mirror ? 'mr-3 order-1' : 'ml-3', 'text-sm']">
      <p v-if="label" class="font-medium text-neutral-900 dark:text-white">{{ label }}</p>
      <p v-if="error" class="text-red-600" :id="hintId"><i class="fa-sharp fa-exclamation-circle"></i> {{ error }}</p>
      <p v-else-if="hint" class="text-neutral-500 dark:text-neutral-400" :id="hintId">
        {{ hint }}
      </p>
    </SwitchLabel>
  </SwitchGroup>
</template>

<script>
import Str from 'laravel-js-str'
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue'

export default {
  components: {
    Switch, // eslint-disable-line vue/no-reserved-component-names
    SwitchGroup,
    SwitchLabel
  },
  emits: ['update:model-value', 'change'],
  inject: {
    form: {
      default: null
    },
    formDisabled: {
      default: false
    }
  },
  props: {
    label: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modelValue: {
      default: null
    },
    mirror: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    id() {
      return Str.random()
    },
    hintId() {
      return this.hint || this.error ? `${this.id}Hint` : null
    },
    error() {
      if (!this.form?.errors || !this.name) {
        return null
      }
      return this.form.errors[this.name]
    },
    content: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:model-value', value)
        this.$emit('change', value)
      }
    }
  }
}
</script>
